import { Head } from '@inertiajs/react'
import AppLayout from '@/components/AppLayout'
import { GiftCodesPage } from '@/components/screens/GiftCodesScreen'

/* The Inertia boundary. The screen below still reads from @/fixtures; when a
 * controller starts handing this page real props they get passed through here,
 * and the screen stops importing fixtures at all. */
export default function GiftCodes() {
  return (
    <AppLayout>
      <Head title="Gift Codes" />
      <GiftCodesPage />
    </AppLayout>
  )
}
